import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import React from "react";
import { createPortal } from "react-dom";
import { Box } from "./Box";
import { SlotsProvider } from "../providers/SlotsProvider";
import { mergeSx } from "../system";
import { GlobalCss } from "./GlobalCss";
export const mobileDesktopEmulatorSlots = {
    root: Box,
    frameRoot: Box,
    cacheProvider: CacheProvider,
};
export const appendLinkTags = (params) => {
    // biome-ignore lint/complexity/noForEach: <explanation>
    params.links?.forEach((linkInfo) => {
        const link = params.document?.createElement("link");
        link?.setAttribute("rel", linkInfo.rel);
        link?.setAttribute("href", linkInfo.href);
        link && params.head?.appendChild(link);
    });
};
export const MobileDesktopEmulator = ({ height, width, children, links, disableResize, slots, slotProps, ...iframeProps }) => {
    const [iframeRef, setIframeRef] = React.useState(null);
    const iframeDocument = iframeRef?.contentWindow?.document;
    const iframeHeadNode = iframeRef?.contentWindow?.document?.head;
    const iframeBodyNode = iframeRef?.contentWindow?.document?.body;
    const muiCache = createCache({
        key: "mui",
        container: iframeHeadNode,
        prepend: true,
    });
    const [iframeLoaded, setIframeLoaded] = React.useState(false);
    const handleLoad = () => {
        clearInterval(loadCheck);
        if (!iframeLoaded) {
            setIframeLoaded(true);
        }
    };
    if (iframeDocument) {
        // The DOMContentLoaded event is supported by all major web browsers
        // It is important to note that the availability of this event may
        // vary slightly depending on the browser versions.
        // However, it is widely supported and can be used in most modern browsers.
        iframeRef.contentWindow?.addEventListener("DOMContentLoaded", () => handleLoad());
    }
    // In certain situations on a cold cache DOMContentLoaded never gets called
    // fallback to an interval to check if that's the case
    // This is also a fallback for browser versions that don't support DOMContentLoaded
    const loadCheck = setInterval(() => {
        handleLoad();
    }, 500);
    return (_jsx(SlotsProvider, { baseSlots: mobileDesktopEmulatorSlots, slots: slots, children: ({ root: Root, frameRoot: FrameRoot, cacheProvider: CacheProvider }) => {
            return (_jsx(Root, { width: "100%", height: "100%", ...slotProps?.root, sx: mergeSx({
                    alignItems: "flex-start",
                    justifyContent: "center",
                    display: "flex",
                }, slotProps?.root?.sx), children: _jsx(FrameRoot, { sx: mergeSx({
                        alignItems: "stretch",
                        display: "flex",
                        justifyContent: "center",
                        resize: disableResize ? undefined : "both",
                        overflow: "auto",
                        width: width,
                        height: height,
                    }, slotProps?.frameRoot?.sx), ...slotProps?.frameRoot, children: _jsx("iframe", { ...iframeProps, ref: setIframeRef, title: "desktop-mobile-emulator", width: width, height: height, style: {
                            border: "none",
                            ...iframeProps?.style,
                        }, children: _jsxs(CacheProvider, { value: muiCache, ...slotProps?.cacheProvider, children: [iframeHeadNode &&
                                    iframeLoaded &&
                                    createPortal(_jsx(_Fragment, { children: appendLinkTags({
                                            links,
                                            document: iframeDocument,
                                            head: iframeHeadNode,
                                        }) }), iframeHeadNode), iframeBodyNode &&
                                    iframeLoaded &&
                                    createPortal(_jsxs(_Fragment, { children: [_jsx(GlobalCss, {}), children] }), iframeBodyNode)] }) }) }) }));
        } }));
};
//# sourceMappingURL=MobileDesktopEmulator.js.map